<template>
    <div class="esepom_swiper">
        <div class="list2">
            <div class="item" :class="{active: item.show}" v-for="(item, index) in list2" :key="index">
                <div class="cover" :style="`background: url(${item.image})`"></div>
                <div class="text_wrap">
                    <div class="text">{{item.text}}</div>
                    <div class="btn" @click="item.show = true"></div>
                    <div class="desc">
                        <p v-html="textToHtml(item.desc)"></p>
                        <div class="btn" @click="item.show = false"></div>
                    </div>
                </div>
            </div>
        </div>
        <swiper ref="swiper" class="swiper" :options="options">
            <template v-for="(item, index) in list2">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.image});`"></div>
                    <p class="title">{{item.text}}</p>
                    <p class="text" v-html="textToHtml(item.desc)"></p>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import lineBreaks from '../utils/lineBreaks';
export default {
    name: "esepomSwiper",
    data() {
        return {
            options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: '.esepom_swiper .swiper-button-prev',
                    nextEl: '.esepom_swiper .swiper-button-next',
                },
                autoHeight: true,
            },
            list2: [
                {
                    show: false,
                    image: require('@/assets/images/images_esg_2_1.jpg'),
                    web_image: require('@/assets/images/images_esg_2_11.jpg'),
                    text: '可持续设计',
                    desc: '建筑设计\r办公环境设计'
                },
                {
                    show: false,
                    image: require('@/assets/images/images_esg_2_2.jpg'),
                    web_image: require('@/assets/images/images_esg_2_12.jpg'),
                    text: '低碳办公运营',
                    desc: '能源 & 资源使用\r办公采购 & 运维\r日常运营\r会议 & 活动'
                },
                {
                    show: false,
                    image: require('@/assets/images/images_esg_2_3.jpg'),
                    web_image: require('@/assets/images/images_esg_2_13.jpg'),
                    text: '绿色工作方式',
                    desc: '日常办公\r出行\r餐饮'
                },
            ],
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        textToHtml: lineBreaks.textToHtml,
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    watch: {},
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.esepom_swiper{
    position: relative;
    .swiper-button-prev,
    .swiper-button-next{
        width: .64rem;
        height: .82rem;
        background: no-repeat 0/100%;
        top: 3.67rem;
        margin-top: -.41rem;
        display: none;
        @media only screen and (max-width: 1200px) {
            display: block;
        }
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: .35rem;
        background-image: url('~@/assets/images/icon_arrow_prev3.svg');
    }
    .swiper-button-next{
        right: .35rem;
        background-image: url('~@/assets/images/icon_arrow_next3.svg');
    }
}
.swiper{
    display: none;
    @media only screen and (max-width: 1200px) {
        display: block;
        .swiper-slide{
            background: #15764a;
            color: #fff;
            padding-bottom: .5rem;
            text-align: center;
            .cover{
                width: 100%;
                height: 8.16rem;
                background: no-repeat center/cover;
                margin-bottom: .5rem;
            }
            .title{
                font-size: .48rem;
                font-weight: bold;
                margin-bottom: .2rem;
            }
        }
    }
}
.list2{
    display: flex;
    margin: 1rem 0;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    .item{
        flex: 1;
        &.active{
            .text_wrap{
                .desc{
                    display: block;
                }
                .btn{
                    display: none;
                }
                .desc{
                    .btn{
                        display: block;
                    }
                }
            }
        }
        .cover{
            width: 2.76rem;
            height: 2.76rem;
            background: no-repeat center/cover;
            border-radius: 50%;
            margin: 0 auto .3rem;
        }
        .text_wrap{
            width: 2.24rem;
            margin: 0 auto;
            color: #fff;
            position: relative;
            .text{
                height: .48rem;
                border-radius: .48rem;
                background: #15764a;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .24rem;
            }
            .desc{
                display: none;
                width: 1.6rem;
                background: rgba($color: #15764a, $alpha: .5);
                text-align: center;
                margin: 0 auto;
                border-radius: 0 0 .04rem .04rem;
                padding: .1rem 0 .3rem;
                font-size: .14rem;
                position: relative;
                .btn{
                    bottom: .09rem;
                    background-image: url('~@/assets/images/icon_arrow_next2.svg');
                    transform: translate(-50%, 0) rotate(-90deg);
                }
            }
            .btn{
                content: "";
                position: absolute;
                width: .12rem;
                height: .15rem;
                background: url('~@/assets/images/icon_arrow_next3.svg') no-repeat 0/100%;
                left: 50%;
                bottom: -.21rem;
                transform: translate(-50%, 0) rotate(90deg);
                cursor: pointer;
            }
        }
    }
}
</style>